export function chartSeriesHasValues(rows, dataKey = 'Rent') {
  if (!Array.isArray(rows) || rows.length === 0) return false;
  return rows.some((row) => Number(row?.[dataKey]) > 0);
}
